import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect, useLocation, withRouter } from 'react-router-dom';
import { onAuthStateChanged } from "firebase/auth";
import { useTranslation } from 'react-i18next';
import { BeatLoader } from 'react-spinners';

import { Role } from './_helpers';
import { accountService, alertService } from './_services';
import { Nav, PrivateRoute, Alert } from './_components';
import { Default } from './Default';
import { Default2 } from './Default2';
import { Profile } from './profile';
import { Admin } from './admin';
import { Account } from './account';
import { About } from './About';
import { Project } from './Project';
import { Contact } from './Contact';
import { Quote } from './Quote';
import { auth, } from './_firebase';
import { isMobile } from 'react-device-detect';


function App(history) {
    const { pathname } = useLocation();
    const [pending, setPending] = useState(true);

    const { t } = useTranslation();

    useEffect(() => {
        return onAuthStateChanged(auth, (user) => {

            setPending(false);

            if (user) {
                

                const localUser = {
                    id: user.uid,
                    displayName: user.displayName,
                    email: user.email,
                    emailVerified: user.emailVerified,
                    jwtToken: user.accessToken
                }

                setPending(true);

                accountService.userSubject.next(localUser);

            }
            else {
                setPending(false);
                accountService.userSubject.next(null);
                console.log(auth);
            }
        });
    }, []);

    // if (pending) {

    // }
    // else {

    return (
        <div className={ 'app-container container' + (isMobile ? ' mobile-app-container' : '') }>
            {pending && <div className='vh-100 d-flex justify-content-center align-items-center'>
                <BeatLoader
                    color={"Grey"}
                    loading={true}
                    cssOverride={{
                        display: "block",
                        margin: "0 auto"
                    }}
                    size={25}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>
            }
            <Nav />
            <Alert />
            <Switch>
                <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
                <PrivateRoute path="/profile" component={Profile} />
                <PrivateRoute path="/admin" roles={[Role.Manager]} component={Admin} />
                <Route exact path="/index.html" component={Default} />
                <Route exact path="/" component={Default} />
                <Route exact path="/new" component={Default2} />
                <Route path="/account" component={Account} />
                <Route path="/about" component={About} />
                <Route path="/project" component={Project} />
                <Route path="/quote" component={Quote} />
                <Route path="/contact" component={Contact} />
                {/* <Route path="/locales/en.json" to="/locales/en.json" />
                    <Redirect from="*" to="/" /> */}
            </Switch>
        </div>
    );
    // }
}

export { App }; 